<script setup>

import { computed, onMounted, ref } from 'vue';
import { useAuthStore } from "@/app/stores/authStore";

const materialTypes = ref([])
const materialType = ref();

const serialNumber = ref();
const aditionalComments = ref('')
const deliveryDate = ref();

const returnDate = ref();
const confirmationTypes = ref([])
const employeeConfirmation = ref();

const confirmationDate = ref();
const returnTypes = ref([])
const employeeReturn = ref();

const returnDateRequest = ref();
const confirmationRequestTypes = ref([])
const employeeConfirmationRequest = ref();

const employeeId = computed((() => {
    return user.value.id;
}))

const user = computed(() => {
    return authStore.getUserLogged;
})

const authStore = useAuthStore();

onMounted(() => {
})

const closeDialog = () => {

}

</script>

<template>
    <div>
        <div class="header">
            <img style="width: 30px; margin-bottom: 14px;" src="@/assets/icons/box-blue.svg">
            <span class="header-title pl-4">
                Mi Material
            </span>
        </div>
        <div class="row f-flex">
            <div class="col-6 el-col-xs-24">
                <div class="form-item date-picker mt-4 w-100 label-common pl-5">
                    <label for="ffrom" class="w-100">Fecha de solicitud</label>
                    <el-date-picker popper-class="material-modal-picker" id="ffrom" v-model="deliveryDate" name="deliv-date'" type="datetime"
                        placeholder="Fecha de solicitud" format="DD/MM/YYYY HH:mm" value-format="YYYY-MM-DD HH:mm"
                        :picker-options="{ firstDayOfWeek: 1 }" />
                </div>
            </div>
            <div class="col-6 el-col-xs-24">
                <div class="form-item date-picker mt-4 w-100 label-common pl-5">
                    <label for="ffrom" class="w-100">ID empleado</label>
                    <el-input type="text" v-model="employeeId" placeholder="Escribe tus comentarios" :rows="5"
                        :readonly="true" />
                </div>
            </div>
            <div class="col-12 mt-3">
                <label for="ffrom" class="w-100">Descripción material</label>
                <el-input type="textarea" v-model="aditionalComments" placeholder="Escribe tus comentarios" :rows="5"
                    class="custom-textarea" />
            </div>
            <div class="col-6 el-col-xs-24 mt-3">
                <label for="ffrom" class="w-100">Tipo de material</label>
                <el-select popper-class="material-modal-select" v-model="materialType" filterable placeholder="Seleccione un tipo de material"
                    :value-key="'@id'">
                    <el-option v-for="type in materialTypes" :key="type.id" :label="type.name" :value="type">
                    </el-option>
                </el-select>
            </div>
            <div class="col-6 el-col-xs-24 mt-3">
                <label for="ffrom" class="w-100">Número de serie</label>
                <el-input v-model="serialNumber" placeholder="Introduce el número de serie" />
            </div>
            <div class="col-6 el-col-xs-24">
                <div class="form-item date-picker mt-4 w-100 label-common pl-5">
                    <label for="ffrom" class="w-100">Fecha de devolución</label>
                    <el-date-picker popper-class="material-modal-picker" id="ffrom" v-model="returnDate" name="return-date'" type="datetime"
                        placeholder="Fecha de devolución" format="DD/MM/YYYY HH:mm" value-format="YYYY-MM-DD HH:mm"
                        :picker-options="{ firstDayOfWeek: 1 }" />
                </div>
            </div>
            <div class="col-6 el-col-xs-24 mt-3">
                <label for="ffrom" class="w-100">Confirmación empleado</label>
                <el-select popper-class="material-modal-select" v-model="employeeConfirmation" filterable placeholder="Seleccione una confirmación"
                    :value-key="'@id'">
                    <el-option v-for="type in confirmationTypes" :key="type.id" :label="type.name" :value="type">
                    </el-option>
                </el-select>
            </div>
            <div class="col-6 el-col-xs-24">
                <div class="form-item date-picker mt-4 w-100 label-common pl-5">
                    <label for="ffrom" class="w-100">Fecha confirmación</label>
                    <el-date-picker popper-class="material-modal-picker" id="ffrom" v-model="confirmationDate" name="return-date'" type="datetime"
                        placeholder="Fecha de devolución" format="DD/MM/YYYY HH:mm" value-format="YYYY-MM-DD HH:mm"
                        :picker-options="{ firstDayOfWeek: 1 }" />
                </div>
            </div>
            <div class="col-6 el-col-xs-24 mt-3">
                <label for="ffrom" class="w-100">Devolución empleado</label>
                <el-select popper-class="material-modal-select" v-model="employeeReturn" filterable placeholder="Seleccione una devolución"
                    :value-key="'@id'">
                    <el-option v-for="type in returnTypes" :key="type.id" :label="type.name" :value="type">
                    </el-option>
                </el-select>
            </div>
            <div class="col-6 el-col-xs-24">
                <div class="form-item date-picker mt-4 w-100 label-common pl-5">
                    <label for="ffrom" class="w-100">Fecha solicitud devolución</label>
                    <el-date-picker popper-class="material-modal-picker" id="ffrom" v-model="returnDateRequest" name="return-date'" type="datetime"
                        placeholder="Fecha solicitud devolución" format="DD/MM/YYYY HH:mm"
                        value-format="YYYY-MM-DD HH:mm" :picker-options="{ firstDayOfWeek: 1 }" />
                </div>
            </div>
            <div class="col-6 el-col-xs-24 mt-3">
                <label for="ffrom" class="w-100">Confirmación devolución</label>
                <el-select popper-class="material-modal-select" v-model="employeeConfirmationRequest" filterable placeholder="Seleccione una confirmación"
                    :value-key="'@id'">
                    <el-option v-for="type in confirmationRequestTypes" :key="type.id" :label="type.name" :value="type">
                    </el-option>
                </el-select>
            </div>
        </div>
        <!--  Botones guardar y cancelar -->
        <div class="row footer">
            <div class="col-md-12 mt-4" style="margin-left: -10px;">
                <div class="d-flex justify-content-end gap-3">
                    <div class="col-md-3">
                        <button class="btn btn-block btn_yellow edit-button" @click="closeDialog" style="">Cancelar
                        </button>
                    </div>
                    <div class="col-md-3">
                        <button type="submit" class="btn btn-block btn_red edit-button" @click="saveEntry">
                            Confirmar entrega
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.header-title {
    font-size: 30px;
    margin-left: 5px;
    font-weight: 800;
    letter-spacing: -0.05em;
    color: #474ce6;
}

.custom-textarea:deep(.el-textarea__inner) {
    font-size: 14px !important;
    border-radius: 20px;
}

@media (max-width: 500px) {
    .header-title {
        font-size: 25px;
    }
}
</style>